import { trackEvent } from 'lib/ui-analytics';
import { createUserInteraction } from '../utils';

import { TRACKING_ACTION, TRACKING_INTERACTION } from '../Constants';

export const utagOfferPillClicked = () => {
  const interaction = createUserInteraction({
    eventType: TRACKING_ACTION.INTERACTIONS,
    interaction:
      TRACKING_INTERACTION.TARGETED_OFFERS.PILL_TARGETED_OFFERS_CLICK,
  });
  trackEvent(interaction);
};
